// Full-page auth/boot screens (loading + error), shared by AuthProvider (MSAL
// boot) and TenantGate (post-login tenant-membership gate). Extracted from
// AuthProvider so both surfaces render the SAME brand-consistent screen.

import { BrandLockup } from "@/components/shell/BrandLogo";

export function BekaertWordmark() {
  return <BrandLockup size="lg" />;
}

export function AuthScreen({ variant, message }: { variant: "loading" | "error"; message?: string }) {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-8 bg-[var(--surface-canvas)] px-6 text-center text-[var(--text-primary)]">
      <BekaertWordmark />
      {variant === "loading" ? (
        <div className="flex flex-col items-center gap-4" role="status" aria-live="polite">
          <span
            className="h-6 w-6 animate-spin rounded-full border-2 border-[var(--border-strong)] border-t-[var(--accent-primary)] motion-reduce:animate-none"
            aria-hidden="true"
          />
          <p className="type-body text-[var(--text-secondary)]">Preparing your workspace…</p>
        </div>
      ) : (
        <div className="flex max-w-md flex-col items-center gap-3" role="alert">
          <h1 className="type-h2 text-[var(--text-primary)]">Sign-in needs attention</h1>
          <p className="type-body-lg text-[var(--text-secondary)]">
            {message || "We couldn't complete authentication."} Try clearing site data and reloading; if it persists,
            check the browser console and the rag-api Entra app registration.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="type-cta mt-2 rounded-[var(--radius-pill)] bg-[var(--accent-primary)] px-6 py-2.5 text-[var(--text-on-accent)] transition-colors duration-[var(--dur-fast)] hover:bg-[var(--accent-hover)] focus-visible:outline-none focus-visible:shadow-[var(--elev-focus)]"
          >
            Reload
          </button>
        </div>
      )}
    </div>
  );
}
